import React from 'react'

import { GridElement } from '..'

export const Media: React.FC<GridElement> = props => {
    const { image, altText, caption } = props.value
    return (
        <>
            <img src={image} width={'100%'} alt={altText} />
            {!!caption && <p>{caption}</p>}
        </>
    )
}
